export default {"src":"/_next/static/media/desktop.a54d8950.svg","height":89,"width":102};